import React, { Fragment } from 'react';
import NavbarHome from '../pages/components/NavbarHome';
import Tawaran from '../pages/Tawaran';

export default function LayoutdDaftarPenawar() {
  return (
    <Fragment>
      <NavbarHome />
      <Tawaran />
    </Fragment>
  );
}
